/* InputPasswordControlComponent.js */

"use strict";

const InputBaseControlTextfieldComponent = require("@gluenetworks/input_base_control").Textfield;
const Renderer = require("./InputPasswordControlRenderer");
const _ = require("lodash");

class InputPasswordControlComponent extends InputBaseControlTextfieldComponent {
    /**
     * @schema.name Input Password Control
     * @schema.package @gluenetworks/input_password_control
     * @schema.namespace require("@gluenetworks/steve_ui_core").Control.Textfield.InputPassword
     * @schema.events ["Placeholder", "Disabled", "Value", "Visible", "Invalid", "DarkTheme", "Focus", "Blur", "SetAttribute", "UserValue", "UserFocus", "UserBlur", "UserKeyDown", "AutocompleteHint", "Required"]
     *
     * @schema.configuration.placeholder.name placeholder
     * @schema.configuration.placeholder.type string
     * @schema.configuration.placeholder.default "Enter Your Password"
     * @schema.configuration.placeholder.required false
     *
     * @schema.configuration.autocompleteHint.name autocompleteHint
     * @schema.configuration.autocompleteHint.type string
     * @schema.configuration.autocompleteHint.default "new-password"
     * @schema.configuration.autocompleteHint.required false
     *
     */
    constructor(configOptions) {
        super(configOptions);

        this._DEFAULT_PLACEHOLDER = "Enter Your Password";
        this._placeholder = _.get(configOptions, "placeholder", this._DEFAULT_PLACEHOLDER);

        this._disablePasswordMgt = _.get(configOptions, "disablePasswordMgt", true);
        this._autocompleteHint = _.get(configOptions, "autocompleteHint", "new-password");

        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._disabled = undefined;
            this._invalid = undefined;
            this._visible = undefined;
            this._value = undefined;
            this._darkTheme = undefined;
            this._theme = undefined;
            this._placeholder = undefined;
            this._disablePasswordMgt = undefined;
            this._autocompleteHint = undefined;
            this._DEFAULT_PLACEHOLDER = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /**
     * @schema.methods.setDisablePasswordMgt.name setAutocompleteHint
     * @schema.methods.setDisablePasswordMgt.description Sets the setDisablePasswordMgt property on the control and returns an instance of the control for chainability
     * @schema.methods.setDisablePasswordMgt.returns Instance of the control
     * @schema.methods.setDisablePasswordMgt.parameters.newVal.name newVal
     * @schema.methods.setDisablePasswordMgt.parameters.newVal.description The new setDisablePasswordMgt value
     * @schema.methods.setDisablePasswordMgt.parameters.newVal.type boolean
     */
    setDisablePasswordMgt(newVal) {
        let disablePasswordMgt = !!newVal;
        if (this._disablePasswordMgt !== disablePasswordMgt) {
            this._disablePasswordMgt = disablePasswordMgt;
            this.emit("DisablePasswordMgt", disablePasswordMgt);
        }
        return this;
    }

    /**
     * @schema.methods.getDisablePasswordMgt.name getDisablePasswordMgt
     * @schema.methods.getDisablePasswordMgt.description Returns the disablePasswordMgt property
     * @schema.methods.getDisablePasswordMgt.returns boolean
     */
    getDisablePasswordMgt() {
        return this._disablePasswordMgt;
    }

    get disablePasswordMgt() {
        return this.getDisablePasswordMgt();
    }

    set disablePasswordMgt(newVal) {
        return this.setDisablePasswordMgt(newVal);
    }

    /**
     * @schema.methods.setAutocompleteHint.name setAutocompleteHint
     * @schema.methods.setAutocompleteHint.description Sets the autocomplete property on the control and returns an instance of the control for chainability
     * @schema.methods.setAutocompleteHint.returns Instance of the control
     * @schema.methods.setAutocompleteHint.parameters.newVal.name newVal
     * @schema.methods.setAutocompleteHint.parameters.newVal.description The new autocompleteHint value
     * @schema.methods.setAutocompleteHint.parameters.newVal.type string
     */
    setAutocompleteHint(newVal) {
        let autocompleteHintNewVal = newVal ? newVal : "";
        if (this._autocompleteHint !== autocompleteHintNewVal) {
            this._autocompleteHint = autocompleteHintNewVal;
            this.emit("AutocompleteHint", autocompleteHintNewVal);
        }
        return this;
    }

    /**
     * @schema.methods.getAutocompleteHint.name getAutocompleteHint
     * @schema.methods.getAutocompleteHint.description Returns the autocompleteHint property
     * @schema.methods.getAutocompleteHint.returns string
     */
    getAutocompleteHint() {
        return this._autocompleteHint;
    }

    get autocompleteHint() {
        return this.getAutocompleteHint();
    }

    set autocompleteHint(newVal) {
        return this.setAutocompleteHint(newVal);
    }

    /**
     * @schema.methods.getViolations.name getViolations
     * @schema.methods.getViolations.description Returns list of validation violations. For Example: returns validation messages when the text value doesn't
     *          match given regular expression (pattern) or is left blank when it is required
     * @schema.methods.getViolations.returns {Array}
     */
    getValidationMessages() {
        return this._renderer.getViolations().slice(0);
    }

    get validationMessages() {
        return this.getValidationMessages();
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}
module.exports = InputPasswordControlComponent;
